import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 text-gray-700 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/sws-logo.png" 
                alt="Safety Workwear Shop" 
                className="h-10 w-auto"
              />
              <div>
                <div className="text-gray-900 font-semibold text-lg">PPE Certificate Portal</div>
                <div className="text-gray-500 text-sm">Powered by Safety Workwear Shop</div>
              </div>
            </div>
            <p className="text-gray-600 mb-4 max-w-md">
              Find, understand, and match safety equipment to the right EU standards - all in one place.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.safety-workwear-shop.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
              >
                Visit Main Shop →
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                  Search Certificates
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.safety-workwear-shop.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  Safety Workwear Shop
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-semibold text-lg mb-4">Contact</h3>
            <div className="space-y-2 text-gray-600">
              <p>Questions about PPE?</p>
              <p>Visit our main shop for expert advice</p>
              <a 
                href="https://www.safety-workwear-shop.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors duration-200 font-medium"
              >
                safety-workwear-shop.com
              </a>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-200 mt-8 pt-8">
          <div className="text-center">
            <p className="text-gray-500 text-sm leading-relaxed max-w-4xl mx-auto">
              <strong>Disclaimer:</strong> The information provided on this website is for general informational purposes only. 
              While we strive to keep the information up to date and correct, we make no representations or warranties of any kind, 
              express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, 
              products, services, or related graphics contained on the website for any purpose. Any reliance you place on such 
              information is therefore strictly at your own risk. We are not responsible for any decisions made based on the 
              information provided on this website.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Safety Workwear Shop. All rights reserved.
          </div>
          <div className="flex items-center space-x-2 text-sm text-gray-500">
            <span>PPE Certificate Portal powered by</span>
            <img 
              src="/sws-logo.png" 
              alt="Safety Workwear Shop" 
              className="h-6 w-auto opacity-60"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
